import {presentationRegistry} from '../core/presentation-registry';
import {defaultTheme} from './default';
import {skydiveTheme} from './skydive';

let registered = false;

export function registerBuiltinThemes(): void {
  if (registered) return;
  presentationRegistry.registerTheme(defaultTheme);
  presentationRegistry.registerTheme(skydiveTheme);
  registered = true;
}
